<div class="list-page kapea" style="max-width: 1000px">
  <h2>Laskujen tilastojen siirto</h2>

  @if (siirtoOnnistui()) {
    <div class="success-message">Laskujen tilastotietojen siirto lisättiin käsittelyjonoon onnistuneesti. Siirto käsitellään taustalla.</div>
  }

  @if (siirtoVirhe()) {
    <div class="error-message">
      {{ siirtoVirhe() }}
    </div>
  }

  <form novalidate>
    @if (kirjanpitajienNimitiedotObservable | async; as kirjanpitajat) {
      <div class="transfer-layout">
        <div class="transfer-card from-card">
          <div class="card-header from-header">
            <mat-icon>person</mat-icon>
            <h3 class="section-header">Mistä siirretään</h3>
          </div>
          <div class="card-body">
            <mat-form-field class="form-field-with-margin">
              <mat-label>Nykyinen kirjanpitäjä</mat-label>
              <mat-select [formField]="lomake.vanhaKirjanpitaja">
                @for (kp of kirjanpitajat; track kp.avain) {
                  <mat-option [value]="kp.avain"> {{ kp.etunimi }} {{ kp.sukunimi }} </mat-option>
                }
              </mat-select>
              @if (lomake.vanhaKirjanpitaja().invalid() && lomake.vanhaKirjanpitaja().touched()) {
                <mat-error> Kirjanpitäjä vaaditaan </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="form-field">
              <mat-label>Aiempi tiimi (vapaaehtoinen)</mat-label>
              <mat-select [formField]="lomake.vanhaTiimi">
                <mat-option [value]="null">Ei valintaa</mat-option>
                @for (tiimi of vanhanKirjanpitajanTiimitObservable | async; track tiimi.avain) {
                  <mat-option [value]="tiimi.avain"> {{ tiimi.nimi }} ({{ tiimi.alku | lnumberpvm | async }} - {{ tiimi.loppu | lnumberpvm | async }}) </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="transfer-arrow">
          <mat-icon>arrow_forward</mat-icon>
        </div>

        <div class="transfer-card to-card">
          <div class="card-header to-header">
            <mat-icon>person_add</mat-icon>
            <h3 class="section-header">Mihin siirretään</h3>
          </div>
          <div class="card-body">
            <mat-form-field class="form-field-with-margin">
              <mat-label>Uusi kirjanpitäjä</mat-label>
              <mat-select [formField]="lomake.uusiKirjanpitaja">
                @for (kp of kirjanpitajat; track kp.avain) {
                  <mat-option [value]="kp.avain"> {{ kp.etunimi }} {{ kp.sukunimi }} </mat-option>
                }
              </mat-select>
              @if (lomake.uusiKirjanpitaja().invalid() && lomake.uusiKirjanpitaja().touched()) {
                <mat-error> Kirjanpitäjä vaaditaan </mat-error>
              }
            </mat-form-field>

            <mat-form-field class="form-field">
              <mat-label>Uusi tiimi</mat-label>
              <mat-select [formField]="lomake.uusiTiimi">
                @for (tiimi of uudenKirjanpitajanTiimitObservable | async; track tiimi.avain) {
                  <mat-option [value]="tiimi.avain"> {{ tiimi.nimi }} ({{ tiimi.alku | lnumberpvm | async }} - {{ tiimi.loppu | lnumberpvm | async }}) </mat-option>
                }
              </mat-select>
              @if (lomake.uusiTiimi().invalid() && lomake.uusiTiimi().touched()) {
                <mat-error> Tiimi vaaditaan </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="date-card">
        <div class="card-header date-header">
          <mat-icon>date_range</mat-icon>
          <h3 class="section-header">Päivämäärärajaus <span class="optional-label">(vapaaehtoinen)</span></h3>
        </div>
        <div class="card-body date-fields">
          <mat-form-field class="form-field">
            <mat-label>Päivämäärä alkaen</mat-label>
            <input matInput [matDatepicker]="pickerAlku" [formField]="lomake.pvmAlkaen" />
            <mat-datepicker-toggle matSuffix [for]="pickerAlku"></mat-datepicker-toggle>
            <mat-datepicker #pickerAlku></mat-datepicker>
            @if (onkoVirhe(lomake.pvmAlkaen, 'paivamaaraVirhe')) {
              <mat-error> Alkupäivämäärä ei voi olla myöhempi kuin loppupäivämäärä </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="form-field">
            <mat-label>Päivämäärä päättyen</mat-label>
            <input matInput [matDatepicker]="pickerLoppu" [formField]="lomake.pvmPaattyen" />
            <mat-datepicker-toggle matSuffix [for]="pickerLoppu"></mat-datepicker-toggle>
            <mat-datepicker #pickerLoppu></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    }

    <div class="controls-container">
      <app-primary-button (click)="suoritaSiirto()" [disabled]="lomake().invalid() || siirtoKaynnissa()" actionId="Laskujen tilastojen siirto: suorita siirto" [actionContext]="[lomake().value()]">
        {{ siirtoKaynnissa() ? 'Käsitellään...' : 'Suorita siirto' }}
      </app-primary-button>

      <app-secondary-button (click)="nollaaLomake()" [disabled]="siirtoKaynnissa()" actionId="Laskujen tilastojen siirto: peruuta"> Peruuta </app-secondary-button>
    </div>
  </form>

  <div class="instructions-section">
    <h3>Käyttöohje</h3>
    <p class="instructions-desc">Tämä työkalu siirtää laskujen ja liittyvien laskujen tilastot kirjanpitäjältä toiselle. Vahvista siirto aina vähintään yhdeltä toiselta henkilöltä.</p>
    <ol>
      <li><strong>Mistä siirretään:</strong> Valitse nykyinen kirjanpitäjä ja halutessasi tiimi.</li>
      <li><strong>Mihin siirretään:</strong> Valitse uusi kirjanpitäjä ja tiimi.</li>
      <li><strong>Päivämäärärajaus (vapaaehtoinen):</strong> Rajaa siirto aikaväliin (molemmat päivämäärät tai vain toinen). Jos tyhjä, kaikki laskut siirretään.</li>
      <li>Klikkaa <strong>Suorita siirto</strong> ja vahvista. Siirto laitetaan työjonoon, tarkasta työjonot.</li>
    </ol>

    <div style="font-size: 0.85em; margin-top: 1rem">
      <strong>Huomioitavaa kampanjahyvityslaskuista:</strong>
      <ul>
        <li>Kampanjahyvitykset ovat tilastoitu ainoastaan yhdelle henkilölle - tämän henkilön tilastot / kampanjahyvityslaskujen tilastot tulisi pyytää aina siirrettäväksi erikseen (ei työkalun kautta).</li>
      </ul>
    </div>
  </div>
</div>
